/**
 * 메뉴 표시 컴포넌트
 */

import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import {Stack, Typography,Box} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import icon from "../../assets/images/icon/blet.png";
import { fni18n } from "../../services/commonService";

const UBreadCrumbs = (props) => {
  const breadcrumbs = [
    <Typography variant="h6" key="1" color="textPrimary" sx={{ fontWeight: 500, fontStyle: "italic" }}>
      {props.title && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img src={icon} alt="" style={{ width: '24px', marginRight: '8px' }} />
          <span>{fni18n(props.title)}</span>
        </Box>
      )}
    </Typography>,
    <Typography variant="h6" key="2" color="textPrimary" sx={{ fontWeight: 500, fontStyle: "italic" }}>
      {fni18n(props.subtitle)}
    </Typography>,
  ];
  return (
    <Stack spacing={2} sx={{ mb: 1}}>
      <Breadcrumbs
        size='lg'
        separator={<NavigateNextIcon/>}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
};

export default UBreadCrumbs;
